import React from "react"
import gql from "graphql-tag"
import {CUSTOM_INTEREST_CONTENT_ID, PLACEHOLDER_SCHEDULE_ID} from "@irati/insights/constants/schedule"
import {isEmpty} from "lodash"
import Loader from "@irati/ui/src/Loading/Loader"
import {injectIntl} from "@irati/utils/lang/injectIntl"

import Query from "../Query"
import {cycleFieldsWizardFragment} from "../../gql/fragments/schedule"
import GetInterest from "../interest/get"

export const cycleQuery = gql`
  query GetCycleWizard(
  $tenant: String!,
  $id: String!,
  $overrides: ScheduleOverridesInput,
  $withInterestIdContext: String
  ) {
    schedule(
    tenant: $tenant,
    id: $id,
    overrides: $overrides,
    withInterestIdContext: $withInterestIdContext
    ) {
      ...cycleFieldsWizard
    }
  }
${cycleFieldsWizardFragment}
`

const localQuery = gql`
  query InsightsLocalData {
    insGlobal @client {
      cycleId
      tenant
      interestId
    }
  }
`


const GetCycleWizard = ({children, formatMessage, ...props}) => {
  return (
    <Query query={localQuery}>
      {({data: {insGlobal: {cycleId, tenant, interestId: interestUuid}}}) => {
        const isDefaultCycle = cycleId === PLACEHOLDER_SCHEDULE_ID
        return (
          <GetInterest id={interestUuid} skip={!interestUuid} useLoader={false}>
            {({interest: {contentId}}) => {
              let withInterestIdContext = null
              let overrides = {}

              if (isDefaultCycle) {
                withInterestIdContext = interestUuid
                if (contentId === CUSTOM_INTEREST_CONTENT_ID) {
                  overrides = {
                    runOnce: true,
                    runCount: 1,
                    questionSelectionType: "firstInFirstOut",
                    questionCount: 1,
                    includeDriverComment: true,
                    periodValue: 28
                  }
                }
              }
              const variables = {id: cycleId, tenant, overrides, withInterestIdContext}
              return (
                <Query
                  skip={!cycleId || (isDefaultCycle && !contentId)}
                  query={cycleQuery}
                  variables={variables}
                  {...props}>
                  {({data: {schedule = {}} = {}, ...rest}) => {
                    if (isEmpty(schedule)) return <Loader />
                    return children({schedule, ...rest})
                  }}
                </Query>
              )
            }}
          </GetInterest>
        )
      }}
    </Query>
  )
}

export default injectIntl(GetCycleWizard)
